/* tslint:disable */
/* eslint-disable */
export enum EbsStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
}
